import type { HierarchyScope } from '../../overview/models/hierarchyScope';
import { HierarchyMultiSelect } from '../../controls/components/HierarchyMultiSelect';

interface HierarchyFilterSectionProps {
  /** Distinguishes the dialog's input ids from any other hierarchy on the page. */
  idPrefix: string;
  value: HierarchyScope;
  onChange: (next: HierarchyScope) => void;
}

/**
 * A list's Filter dialog's organization hierarchy (2026-10-09): Business Unit, Division and Department under the
 * entity picked at the top left, each the project's multi-select, none chosen until the user chooses. The list
 * itself opens on the entity alone; these narrow it once the dialog is applied. Nothing is judged -- no required
 * level, no per-parent message.
 */
export function HierarchyFilterSection({ idPrefix, value, onChange }: HierarchyFilterSectionProps) {
  return (
    <section className="mt-3" role="group" aria-label="Organization hierarchy">
      <p className="ms-pop__sub mb-2">Organization hierarchy. Leave a level empty to include all of it.</p>
      <HierarchyMultiSelect
        idPrefix={idPrefix}
        variant="filter"
        value={value}
        onChange={onChange}
        defaultFirst={false}
        checkChildren={false}
      />
    </section>
  );
}
